const menuLinks = [
  {
    id: 1,
    url: '#home',
    text: 'home',
  },
  {
    id: 2,
    url: '#courses',
    text: 'courses',
  },
  {
    id: 3,
    url: '#community',
    text: 'community',
  },
  {
    id: 4,
    url: '#benefits',
    text: 'benefits',
  },
];

export default menuLinks;
